/*
  ak-custom.js — cleaned 9/24 (SFSX).
  Removed: the old "Warm out there?" chocolate box in the cart drawer, its checkbox, the 1-second polling,
  the Hostinger price service calls (lightgrey-butterfly-351538.hostingersite.com), the hidden Checkout / "Cart"
  button swap, the quick-buy redirect to /cart, the 2.5s loading overlay on Add to cart, and unused Slick code.
  Insulated shipping now lives in sections/sfsx-insulated-shipping.liquid.
  Kept: loader helpers (harmless), compare-view search style, image sizing fixes, noscript script loader, YouTube embed fix.
*/
function akShowLoader(){
  if(!document.body.querySelector('.loader-overlay')){
    var div = document.createElement('div');
    div.className = 'loader-overlay';
    div.style.position = 'fixed';
    div.innerHTML = '<div class="loader"></div>';
    document.body.appendChild(div);
  }
}
function akHideLoader(){
  var el = document.body.querySelector('.loader-overlay');
  if(el) el.remove();
}

(function(){
  function ready(fn){
    if(window.jQuery) { jQuery(document).ready(fn); }
    else if (document.readyState === 'complete' || document.readyState === 'interactive') { setTimeout(fn, 0); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function(){
    var params = new URLSearchParams(window.location.search);
    if (params.get('view') === 'compare') {
      var style = document.createElement('style');
      style.innerHTML = '[data-live-search] > form > div:nth-child(1){ flex-wrap: unset !important; } button.live-search-button+#product-restore-quote{ display: none !important; }';
      document.head.appendChild(style);
    }
  });
})();

if (window.jQuery) {
  jQuery(function($){
    $('img').each(function(){
      var rimgTemplateAK = $(this).data('rimg-template');
      if(typeof rimgTemplateAK != 'undefined'){
        var newSrcAK = 'https:' + rimgTemplateAK.replace('{size}', '720x');
        $(this).attr('src', newSrcAK);
        $(this).removeAttr('data-rimg');
        $(this).removeAttr('srcset');
        $(this).removeAttr('data-rimg-scale');
        $(this).removeAttr('data-rimg-template');
        $(this).removeAttr('data-rimg-max');
        $(this).removeAttr('data-rimg-crop');
      }
    });
    $('.pxs-image-with-text-background').each(function(){
      var rimgTemplateAK = $(this).data('rimg-template');
      if (!rimgTemplateAK) return;
      var newSrcAK = 'https:' + rimgTemplateAK.replace('{size}', '720x');
      $(this).css({ 'background-image': "url('" + newSrcAK + "')" });
    });
    $('.promo-block img, .productgrid--item.featured-collection__title-card.featured-collection__title-card--horizontal-size- img').each(function(){
      $(this).css({ 'opacity': 1, 'height': '100%', 'width': '100%' });
    });

    // Run scripts that were placed inside <noscript> tags.
    $('noscript').each(function () {
      var temp = $('<div>').html($(this).html());
      temp.find('script').each(function () {
        var src = $(this).attr('src');
        var inline = $(this).html().trim();
        var script = document.createElement('script');
        if (src) { script.src = src; document.body.appendChild(script); }
        else if (inline) { script.text = inline; document.body.appendChild(script); }
      });
    });

    // YouTube: replace div.youtube placeholders with an embed.
    $('div.youtube').each(function(){
      var link = $(this).data('video-url');
      if (!link) return;
      var id = new URL(link).searchParams.get('v');
      $(this).html('<iframe width="100%" src="https://www.youtube.com/embed/' + id + '?autoplay=0&mute=1" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    });
  });
}
